import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { ToastService } from "app/modules/shared/services/message/toast.service";
import { UnitSetDto } from "app/modules/dashboard/modules/material-management/unit-set/model/unit-set.dto";
import * as wjCore from "wijmo/wijmo";
import { CollectionView } from "wijmo/wijmo";
import * as wjGrid from "wijmo/wijmo.grid";
import "rxjs/add/operator/finally";
import { ApiService } from "app/modules/shared/services/base/api.service";
import { KlLoadingService } from "app/modules/shared/services/kl-loading.service";
import { BaseForm } from "app/data/shared/models/base-form.interface";
import { KlDyModalComponent } from "app/modules/dashboard/components/partials/modal/modal.component";
import { ExplorerService } from "app/modules/shared/services/explorer.service";
import { UtilService } from "app/modules/shared/services/util.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";

@Component({
  selector: "kl-new-unit-set",
  templateUrl: "./unit-set-form.component.html",
  styleUrls: ["./unit-set-form.component.scss"],
})
export class UnitSetFormComponent
  implements OnInit, AfterViewInit, OnDestroy, BaseForm
{
  @ViewChild("unitsetGrid", { static: true }) flex: wjGrid.FlexGrid;
  unitCollectionView: wjCore.CollectionView;
  @ViewChild("focusElement", { static: true }) private elementFocus: ElementRef;
  @ViewChild("newUnitSetForm", { static: true }) private unitSetForm: any;
  @Input() entity: UnitSetDto = new UnitSetDto();
  @Input() isReadOnly: boolean;
  @Input() mode: string;
  @Input() tabId: string;
  @Input() listTabId: string;
  @Input() modalId: string;
  alertShow: boolean;
  alertType: string;
  alertMessage: string;
  saveForm = false;
  isOpen = true;
  unitList: any;
  units = [];
  title: string;

  unitLineDto() {
    const dto = new Array({
      rec_status: "NEW",
      unit: {
        id: this.units[0] ? this.units[0].id : null,
      },
      multiplier: 0,
    });
    return dto[0];
  }

  constructor(
    private toastService: ToastService,
    public klModal: KlDyModalComponent,
    private utilService: UtilService,
    private apiService: ApiService,
    private explorerService: ExplorerService,
    private translateService: TranslateService,
    private klLoadingService: KlLoadingService
  ) {}

  ngOnInit() {
    switch (this.mode) {
      case "add":
        this.title =
          this.translateService.instant("new") +
          " " +
          this.translateService.instant("unit_set");
        this.entity.unit_set_units = [UtilService.deepCopy(this.unitLineDto())];
        break;
      case "view":
      case "edit":
        this.title = this.translateService.instant("unit_set") + " - ";
        break;
    }
    this.unitCollectionView = new wjCore.CollectionView(
      this.entity.unit_set_units
    );
    this.unitCollectionView.trackChanges = true;
    this.apiService
      .getAllData("unit")
      .finally(() => {
        this.klLoadingService.hide();
      })
      .subscribe(
        (resUnit) => {
          if (resUnit === null) {
            this.handleError("error_data");
          } else {
            this.units = resUnit;
            this.unitList = new wjGrid.DataMap(this.units, "id", "code");
            if (this.mode === "add") {
              this.entity.master_unit = this.units[0];
              this.unitCollectionView.sourceCollection[0].unit =
                UtilService.deepCopy(this.units[0]);
            }
          }
        },
        (errUnit) => this.handleError(errUnit)
      );
  }

  ngAfterViewInit() {
    this.elementFocus.nativeElement.focus();
  }

  clearForm() {
    this.elementFocus.nativeElement.focus();
    Object.keys(this.entity).forEach((o) => delete this.entity[o]);
    this.entity.unit_set_units = [this.unitLineDto()];
    this.unitCollectionView = new CollectionView(this.entity.unit_set_units);
  }

  commitSave(action: any) {
    if (this.unitSetForm.valid) {
      for (
        let i = 0;
        i < this.unitCollectionView.sourceCollection.length;
        i++
      ) {
        if (!this.unitCollectionView.sourceCollection[i].unit.id) {
          this.unitCollectionView.remove(
            this.unitCollectionView.sourceCollection[i]
          );
          i = i - 1;
        }
      }
      if (this.unitCollectionView.itemsRemoved.length > 0) {
        for (let i = 0; i < this.unitCollectionView.itemsRemoved.length; i++) {
          if (this.unitCollectionView.itemsRemoved[i].id) {
            if (this.unitCollectionView.itemsRemoved[i].rec_status) {
              this.unitCollectionView.itemsRemoved[i].rec_status = "DELETE";
            } else {
              Object.assign(this.unitCollectionView.itemsRemoved[i], {
                rec_status: "DELETE",
              });
            }
            this.entity.unit_set_units.push(
              this.unitCollectionView.itemsRemoved[i]
            );
          }
        }
      }
      this.saveForm = true;
      this.isReadOnly = true;
      switch (action) {
        case "SAVE":
          switch (this.mode) {
            case "add":
              this.apiService.addData("unitSet", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
            case "edit":
              this.apiService.updateData("unitSet", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
          }
          break;
        case "SAVE_NEW":
          this.apiService.addData("unitSet", this.entity).subscribe(
            (response) => this.handleNew(response),
            (error) => this.handleError(error)
          );
          break;
      }
    } else {
      this.alertShow = true;
      this.alertType = "error";
      this.alertMessage = "required_fields_must_be_entered";
    }
  }

  handleResponse(response) {
    this.saveForm = false;
    this.isReadOnly = false;
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    if (this.modalId) {
      this.explorerService.closeModal(this);
    }
    if (this.listTabId) {
      this.explorerService.setRefreshEndProsseses(this.listTabId);
    }
  }

  handleNew(response) {
    this.saveForm = false;
    this.alertShow = false;
    this.isReadOnly = false;
    this.toastService.toastSuccess();
    this.clearForm();
  }

  handleError(error, commitError = false) {
    if (commitError) {
      if (this.unitCollectionView.sourceCollection) {
        if (this.unitCollectionView.sourceCollection.length === 0) {
          this.addNewRow();
        }
      }
      if (this.entity.unit_set_units) {
        if (this.entity.unit_set_units.length > 0) {
          for (let i = 0; i < this.entity.unit_set_units.length; i++) {
            if (this.entity.unit_set_units[i].rec_status) {
              // rec_status property'i varsa
              if (this.entity.unit_set_units[i].rec_status === "DELETE") {
                // mükerrer obje oluşmasın diye statusu DELETE olan kayıtlar siliniyor
                this.entity.unit_set_units.splice(i, 1);
                i = i - 1;
              }
            }
          }
        }
      }
    }
    this.isReadOnly = false;
    this.saveForm = false;
    this.alertShow = true;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
  }

  lockEntity(id: number) {
    return this.apiService.lockData("unitSet", id);
  }

  unlockEntity() {
    this.apiService.unlockData("unitSet", this.entity.id).subscribe();
  }

  ngOnDestroy() {
    switch (this.mode) {
      case "edit":
        this.unlockEntity();
        break;
    }
  }

  unitCellEdit(event) {}

  unitColumnChange(event) {
    const col = event.flexGrid.columns[event.col];
    const dataItem = event.flexGrid.rows[event.row].dataItem;
    this.unitCollectionView.beginUpdate();
    this.unitCollectionView.editItem(dataItem);
    if (dataItem.id) {
      if (this.entity.unit_set_units[event.row].hasOwnProperty("rec_status")) {
        this.entity.unit_set_units[event.row].rec_status = "EDIT";
      } else {
        Object.assign(this.entity.unit_set_units[event.row], {
          rec_status: "EDIT",
        });
      }
    }
    if (col.binding === "unit.id") {
      let notFoundUnit = true;
      this.units.forEach((unit) => {
        if (dataItem.unit.id === unit.id) {
          notFoundUnit = false;
        }
      });
      if (notFoundUnit) {
        dataItem.unit = UtilService.deepCopy(this.units[0]);
      }
    }
    this.unitCollectionView.commitEdit();
    this.unitCollectionView.endUpdate();
  }

  addNewRow(flexGrid?: any) {
    this.entity.unit_set_units.push(UtilService.deepCopy(this.unitLineDto()));
    this.unitCollectionView.refresh();
    if (flexGrid) {
      const lineRow = this.unitCollectionView.sourceCollection.length;
      const selectedCellRange = flexGrid.selection;
      selectedCellRange.row = lineRow - 1;
      selectedCellRange.col = 1;
      selectedCellRange.row2 = selectedCellRange.row;
      selectedCellRange.col2 = 1;
      flexGrid.select(selectedCellRange);
    }
  }
}
